import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const HomeMaintenanceLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionTips = () => {
    return (
      <>       
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
            <Grid.Column width={9} className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Family2.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} >FRIENDS & FAMILY</p> 
                  <Header.Subheader>
                    <p className={styles.learnMoreAccordionText} > Having friends and family who are handy and able to help with home maintenance is always ideal, 
                        but not always realistic for older adults. Finding good help can often be challenging as well, 
                        so asking friends, neighbors, and other members of the community is a good way to get in touch 
                        with a reliable person</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Worker.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >HIRING PROFESSIONALS</p>
                  <Header.Subheader> 
                    <p className={styles.learnMoreAccordionText} > It is important to have a reliable handyman that the older adult can count on for basic home 
                        maintenance and repair tasks. Be sure to ask for several references and look for experience and 
                        reviews, if possible. </p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Finding the Right Help </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}HomeMaintenanceLearnMore1.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(HomeMaintenanceLearnMore);
